import { computed, unref, type MaybeRef } from "vue";

import { components as OpenAPI } from "@/autogen/openapi";
import { ok } from "@/lib/openapi";
import { useStore as useScaffoldingStore } from "@/store/stores/scaffolding";

import api from "../../base";
import { useGenericListingQuery } from "../generic";
import { useNewsletterId } from "../utils";

export type SurveyPage = OpenAPI["schemas"]["SurveyPage"];

export const useSurveysListingQuery = ({
  enabled = true,
}: { enabled?: MaybeRef<boolean> } = {}) => {
  const newsletterId = useNewsletterId();

  const scaffoldingStore = useScaffoldingStore();
  const isEnabled = computed(() => {
    if (!scaffoldingStore.newsletter?.enabled_features.includes("surveys")) {
      return false;
    }

    return unref(enabled);
  });

  return useGenericListingQuery({
    queryKey: [newsletterId, "surveys", "list"],
    enabled: isEnabled,
    hydrateFrom: "/surveys",
    async fetch({ page, signal }) {
      const data = await ok(
        api.get("/surveys", {
          signal,
          params: {
            query: {
              // @ts-expect-error
              page: page,
            },
          },
        })
      );

      return data;
    },
  });
};
